import { encrypt } from "./auth";
export const getLoginToken = (authData) => {
    const { code, username: loginId, password, loginFor, ODP = '' } = authData;
    const date = new Date();
    const macId = sessionStorage.getItem("X")
    const formattedDate = date
        .toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        })
        .replace(/ /g, "-");
    const formattedTime = date.toLocaleTimeString("en-US", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
    const formattedDateTime = `${formattedDate} ${formattedTime}`;

    let authString = encrypt(
        [formattedDateTime, 1, code, loginId, password, macId || '', ODP].join("~")
    );
    if (loginFor === 'B') {
        authString = encrypt(
            [formattedDateTime, 1, code, loginId, password, macId || '', 1].join("~")
        );
    }
    return "?authentication=" + encodeURIComponent(authString);
};
export const getRedirectUrl = (values) => {
    const { loginFor = "B" } = values;
    const { hostname } = window.location;
    let url = "";
    if (loginFor === "B") {
        url = "https://bus.mavenconnect.tech/";
        if (hostname.includes("mavenconnect.biz")) {
            url = "https://bus.mavenconnect.biz/";
        }
    } else if (loginFor === "C") {
        url = "https://cargo.mavenconnect.tech/";
        if (hostname.includes("mavenconnect.biz")) {
            url = "https://cargo.mavenconnect.biz/";
        }
    }
    if (!url.length) url = "https://cargo.mavenconnect.tech/";
    url = url + getLoginToken(values);
    return url;
};
export const getMaintenanceurl = () => {
    let url = "https://vms.mavenconnect.tech/login";
    if (window.location.hostname.includes("mavenconnect.biz")) {
        url = "https://vms.mavenconnect.biz/login";
    }
    return url;
};
export const getLauncherLink = () => {
    const path = window.location.pathname;
    const isCargo = path.startsWith("/cargo");
    if (window.location.origin.includes('mavenconnect.tech')) {
        if (isCargo) {
            return "https://stagecargoapi.mavenconnect.tech/CargoLauncher/Stage/setup.exe"
        }
        return 'https://busapi.mavenconnect.tech/BusLauncher/Stage/setup.exe'
    } else if (window.location.origin.includes('mavenconnect.biz')) {
        if (isCargo) {
            return 'https://cargoapi.mavenconnect.tech/CargoLauncher/Live/setup.exe'
        }
        return 'https://busapi.mavenconnect.tech/BusLauncher/Live/setup.exe'
    } else {
        if (isCargo) {
            return "https://stagecargoapi.mavenconnect.tech/CargoLauncher/Stage/setup.exe"
        }
        return 'https://busapi.mavenconnect.tech/BusLauncher/Stage/setup.exe'
    }
}
